import { Title1 } from "@components/new/Typo";
import PlacingOrderAddressDropdownItem
  from '../PlacingOrderAddressDropdownItem/PlacingOrderAddressDropdownItem';
import SelectContainer from '@containers/SelectContainer';
import SelectDropdown from '@components/SelectDropdown';
import TextInputContainer from '@containers/TextInputContainer';
import TextInputWithSuggestionsContainer from '@containers/TextInputWithSuggestionsContainer';
import { AddressTemplate, TLabelSelectedItem } from '@api/apiClient';
import { TCitySuggestion } from '@api/apiClient/address';
import { IPlacingOrderAddressFieldsCNProps } from '../../placing-types';
import { TRegion, TAddress } from '@api/apiClient/address';
import { useTranslation } from 'react-i18next';
import styles from "../PlacingOrderForm/PlacingOrderForm.module.scss";

const PlacingOrderAddressFieldsCN: React.FC<IPlacingOrderAddressFieldsCNProps> = (props: IPlacingOrderAddressFieldsCNProps): React.ReactElement => {
  const {
    control,
    emptyAddressWithUpdate,
    fullListAddresses,
    handlerGetFullAddress,
    handlerOnClickDeleteAddress,
    handlerSetCurrentAddress,
    handlerSetSelectedSuggestion,
    labelSelectedItem,
    region,
    regions,
    useSuggestions,
    useAddressSuggestionsForCity,
    useAddressSuggestionsForCityDistrict,
    isMunicipality,
  } = props;

  const { t } = useTranslation();

  const getAddrString = (value: TAddress) => `${value.address} ${value.title} ${value.adcode}`;

  const getSuggestionName = (value: TCitySuggestion) => value.nameCn

  return (
      <div className={styles.addressSection}>
        <SelectDropdown<AddressTemplate>
          defaultSelectedItem={emptyAddressWithUpdate}
          items={fullListAddresses}
          keyExtractor={(item: TLabelSelectedItem) => item.id}
          label={t('placingOrderModalWindow.form.address.addressTitleSender')} // todo - разделение addressTitle/addressTitleSender в зависимости от формы
          labelSelectedItem={() => handlerGetFullAddress(labelSelectedItem)}
          onItemSelect={(id: string) => handlerSetCurrentAddress(id)}
          renderItem={(props: { item: TLabelSelectedItem }) => (
            <PlacingOrderAddressDropdownItem
              handlerGetFullAddress={handlerGetFullAddress}
              handlerOnClickDeleteAddress={handlerOnClickDeleteAddress}
              {...props}
            />
          )}
        />

        <Title1 weight="semiBold">{t('placingOrderModalWindow.form.address.pickUpAddressTitle')}</Title1>

        <div className={styles.addressRow}>
          <SelectContainer<TRegion, AddressTemplate>
            control={control}
            items={regions}
            keyExtractor={(province: TRegion | null) => province?.nameCn ?? ''}
            labelOptionItem={(province: TRegion | null) => province?.nameCn ?? ''}
            name="address.region"
            title={t('placingOrderModalWindow.form.address.region')}
          />

          <TextInputWithSuggestionsContainer<TCitySuggestion, AddressTemplate>
            control={control}
            disabled={!region || isMunicipality}
            name="address.city"
            title={t('placingOrderModalWindow.form.address.city')}
            useSuggestions={useSuggestions}
            getName={getSuggestionName}
            getSelectionValue={getSuggestionName}
          />

          <TextInputWithSuggestionsContainer<TCitySuggestion, AddressTemplate>
            control={control}
            disabled={!region}
            name="address.cityDistrict"
            title={t('placingOrderModalWindow.form.address.cityDistrict')}
            useSuggestions={useAddressSuggestionsForCity}
            getName={getSuggestionName}
            getSelectionValue={getSuggestionName}
          />
        </div>

        <div className={styles.addressRow}>
          <TextInputWithSuggestionsContainer<TAddress, AddressTemplate>
            control={control}
            disabled={!region}
            name="address.street"
            title={t('placingOrderModalWindow.form.address.street')}
            useSuggestions={useAddressSuggestionsForCityDistrict}
            onSelect={handlerSetSelectedSuggestion}
            getName={getAddrString}
            getSelectionValue={(value: TAddress) => value.address}
          />

          <TextInputContainer
            control={control}
            name="address.house"
            title={t('placingOrderModalWindow.form.address.house')}
          />

          <TextInputContainer
            control={control}
            name="address.flat"
            title={t('placingOrderModalWindow.form.address.flatOffice')}
          />

          <TextInputContainer
            control={control}
            name="address.zipCode"
            title={t('placingOrderModalWindow.form.address.zipCode')}
          />
        </div>
      </div>
  );
};

export default PlacingOrderAddressFieldsCN;
